import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class RefundButtonModel extends ButtonBase {
    label: string = 'Refund';
    action: string = ACTION_STATUS.refund;
    matIconName: string;
    colorClass: string;
}